import React, { useState, useRef } from 'react';
import {Link} from "gatsby"
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import ContentBlock from "../Content/content";
import TextField from "./Inputs/TextField";
import TextArea from "./Inputs/TextArea";
import { DatePicker } from 'react-nice-dates'
import TimePicker from 'rc-time-picker';
import 'react-nice-dates/build/style.css'
import 'rc-time-picker/assets/index.css';
import Recaptcha from "./Inputs/Recaptcha";
import { postFormData } from "./api/Api";
import { ScrollToTop, SendMail, FormValidation } from "../Common/utils";
import _ from "lodash";
import moment from 'moment';
import "./Form.scss";
import RadioBox from "./Inputs/Radio"
const BookAValuation = (props) => {
    const recaptchaRef = useRef();
    const initFormState = {
        formname: "Valuation Form",
        fname: '',
        lname: '',
        email: '',
        telephone: '',
        propertytype: '',
        preferredDate: new Date(),
        preferredTime: moment().hour(10).minute(0).format("h:mm a"),
        address: ''
    }
    const validationFields = ['fname', 'lname', 'telephone', 'email', 'address'];
    const [formState, setFormState] = useState(initFormState);
    const [propertytype, setPropertytype] = useState('SELL');
    const [errors, setErrors] = useState({});
    const [errorFlag, setErrorFlag] = useState(false);
    const [showthankyou, setThankyou] = useState(false);
    const [btnProcess, setBtnProcess] = useState(false);
    const [date, setDate] = useState(new Date())
    const [time, setTime] = useState(moment().hour(10).minute(0))
    const handleChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value,
            propertytype: propertytype
        });
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        var validation = FormValidation(formState, validationFields);
        if (validation.status) {
            setErrorFlag(false)
            setErrors(validation.errors)
            const token = await recaptchaRef.current.executeAsync();
            if (token) {
                setBtnProcess(true)
                var postData = _.cloneDeep(formState)
                postData['extra'] = formState;
                recaptchaRef.current.reset();
                postFormData(postData).then(async apiRes => {
                    setThankyou(true)
                    setFormState(initFormState)
                    setBtnProcess(false);
                    scrollTop();
                    setTimeout(() => {
                        setThankyou(false)
                    }, 2000)
                    // GTM tracking event 
                    // gtmEvent({ formType: 'Property Valuation', formName: 'Home Visit Valuation' })
                    var form_label =
                    postData?.propertytype=== "SELL"
                      ? "Valuation - SELL"
                      : "Valuation - LET"
          
                    // tracking event
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                    event: "formSubmit",
                    formType: "form-valuation",
                    formId: "form-valuation",
                    formName: "Valuation Form",
                    formLabel: form_label,
                    })
                    // lets send mail
                    postData['email_temp_user'] = 'valuation_user';
                    postData['email_temp_admin'] = 'valuation_admin';
                    postData['email_subject_user'] = 'Valuation Request';
                    postData['email_subject_admin'] = 'From Web: Book a Valuation';
                    postData['g-recaptcha-response'] = token;
                    await SendMail(postData);
                });

                console.log(postData.propertytype,"formm")
                          
               

            }
        } else {
            setErrors(validation.errors)
            setErrorFlag(true)
            scrollTop();
        }
    }

    const scrollTop = () => {
        ScrollToTop(document.getElementById('form-section'), 100)
    }
    const errClass = (field) => {
        if (errors[field]) {
            return 'field-error';
        }
        return ''
    }
    return (
        <React.Fragment>
            <section className='form-section' id="form-section" >
                <Container>
                    <Row>
                            <Col md={12}>
                                <div className='heading'>
                                    <h2>{props.Title}</h2>
                                    <ContentBlock Content={props.Content} />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className='mortgage-wrapper'>
                                    <div className='form-wrapper'>
                                        {showthankyou && <div className="alert alert-success">
                                            Thank you for your interest. A member of our team will contact you shortly.
                                        </div>}
                                        {
                                            errorFlag &&
                                            <div className="alert alert-danger alert-error">Highlighted fields are required | invalid</div>
                                        }

                                        <div className='form-inputs'>
                                        <Row>
                                            <Col md={6}>
                                            <TextField
                                                label="First Name"
                                                name={`fname`}
                                                placeholder=""
                                                onChange={handleChange}
                                                value={formState[`fname`]}
                                                className={errClass(`fname`)}
                                            />
                                            </Col>
                                            <Col md={6}>
                                            <TextField
                                                label="Last Name"
                                                name={`lname`}
                                                placeholder=""
                                                onChange={handleChange}
                                                value={formState[`lname`]}
                                                className={errClass(`lname`)}
                                            />
                                            </Col>
                                            </Row>
                                            <Row>
                                            <Col md={6}>
                                            <TextField
                                                label="Email Address"
                                                name={`email`}
                                                placeholder=""
                                                onChange={handleChange}
                                                className={errClass(`email`)}
                                                value={formState[`email`]}
                                            />
                                            </Col>
                                            <Col md={6}>
                                            <TextField
                                                type="number"
                                                label="Telephone"
                                                name={`telephone`}
                                                placeholder=""
                                                onChange={handleChange}
                                                className={errClass(`telephone`)}
                                                value={formState[`telephone`]}
                                            />
                                            </Col>
                                            
                                            </Row>
                                            <RadioBox
                                            label={'Would you like to Sell or Let your property?'}
                                            options={['SELL', 'LET']}
                                            name="propertytype"
                                            value={formState[`propertytype`]}
                                            selected={propertytype === "LET" ? 'LET' : 'SELL'}
                                            onChange={handleChange}
                                            handleChange={
                                                (e) => {
                                                if (e.target.value === 'LET') {
                                                    setPropertytype('LET')
                                                } else {
                                                    setPropertytype('SELL')
                                                }
                                            }
                                        }
                                        />

                                        <Row>
                                            <Col md="6">
                                            <Form.Group className='form-wrap'>
                                                    <Form.Label>Preferred Date</Form.Label>

                                                    <DatePicker date={date} onDateChange={setDate}
                                                        format="dd/MM/yyyy"
                                                        minimumDate={new Date()}
                                                    >
                                                        {({ inputProps, focused }) => (
                                                            <div className='date-custom-style'>
                                                            <span className="date-calender-icon"></span>
                                                            <input

                                                                className={'input form-control' + (focused ? ' -focused' : '')}
                                                                {...inputProps}
                                                            />
                                                            </div>
                                                        )}
                                                    </DatePicker>
                                                </Form.Group>
                                               
                                            </Col>
                                            <Col md="6">
                                            <Form.Group className='form-wrap'>
                                                    <Form.Label>Preferred Time</Form.Label>
                                                    <div className='valuation-time'>
                                                        <span className="valuation-clock-icon"></span>
                                                    <TimePicker
                                                        showSecond={false}
                                                        defaultValue={time}
                                                        className="time-picker"
                                                        onChange={(e) => {
                                                            setTime(moment(e).format("h:mm a"))
                                                            setFormState({
                                                                ...formState,
                                                                preferredTime: moment(e).format("h:mm a")
                                                            });
                                                        }}
                                                        format={"h:mm a"}
                                                        use12Hours
                                                        inputReadOnly
                                                    />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                            <TextField
                                                label="Property Address"
                                                name={`address`}
                                                placeholder="Start typing your address"
                                                onChange={handleChange}
                                                value={formState[`address`]}
                                                className={errClass(`address`)}
                                            />
                                        </div>
                                        
                                        <Recaptcha recaptchaRef={recaptchaRef} />
                                        <Button type="submit"
                                            disabled={btnProcess}
                                            onClick={(event) => { handleSubmit(event) }}
                                            className='btn outline width-100'
                                        >Book a valuation</Button>
                                        <div className='form-footer-text'>
                                            By clicking Submit, you agree to our <Link to="/terms-of-use/">Terms & Conditions</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    
                </Container>
            </section>
        </React.Fragment >
    )

}
export default BookAValuation;